import React from 'react';
import Calendar from './Calendar';
import { GiTrashCan } from 'react-icons/gi';
import { WiSunrise } from 'react-icons/wi';
import { GoGraph } from 'react-icons/go';
import { IoCalendar } from 'react-icons/io5';
import { useState } from 'react';
import { BarChart } from './BarChart';

const TableRow = ({ habit, handleDelete, handleDayClick, handleHabitRefresh}) => {

  // styles
  const style = {
    display: 'flex', 
    flexWrap: 'wrap',
    fontSize: '.2rem',
    marginLeft: '20px',
    marginRight: '20px',
    padding: '5px'
  }
  const svgStyle = {
    width: '15%',
    height: 'auto',
    margin: '1%'
  }
  const svgBox = {
    width: '100%',
    display: 'inline-block',
    justifyContent: 'center',
    marginTop: '4%',
    marginBottom: '5%',
    marginLeft: '35%'
  }
  
  const [graphSelected, setGraphSelected] = useState(false);
  
  const handleGraphDisplay = (habit) => {
    let newState = !graphSelected
    setGraphSelected(newState);
  }

  return (
    <tr>
        <h1>{habit.name}</h1>
        <td style={style}>
          {graphSelected === false ?
            <Calendar key={habit.id} habit={habit} handleDayClick={handleDayClick} handleHabitRefresh={handleHabitRefresh}/> :
            <BarChart habit={habit}/>
          }  
            <div style={svgBox}>
              <WiSunrise style={svgStyle} onClick={() => handleHabitRefresh(habit)}/>
              <GiTrashCan style={svgStyle} onClick={() => handleDelete(habit.id)} />
              {graphSelected === false ? 
                <GoGraph style={{...svgStyle, marginLeft: '50%' }} onClick={() => handleGraphDisplay(habit) }/> :
                <IoCalendar style={{...svgStyle, marginLeft: '50%' }} onClick={() => handleGraphDisplay(habit)} />} 
            </div>
        </td>
    </tr>
  )
}

export default TableRow